/* ── Studio Phalsa — About Us Page JS (scroll reveal) ────────── */
(function () {
  'use strict';

  var section = document.getElementById('sp-about-us');
  if (!section) return;

  var targets = section.querySelectorAll('[data-sp-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  targets.forEach(function (el) { io.observe(el); });

  // Our Philosophy pagination pill — single philosophy block today, so the
  // arrows are inert but wired up in case more blocks are added later.
  var prevBtn = section.querySelector('[data-sp-philosophy-prev]');
  var nextBtn = section.querySelector('[data-sp-philosophy-next]');
  [prevBtn, nextBtn].forEach(function (btn) {
    if (!btn) return;
    btn.addEventListener('click', function () {
      var body = section.querySelector('.sp-about-us__philosophy-body');
      if (!body) return;
      body.animate(
        [{ opacity: 1 }, { opacity: 0.4 }, { opacity: 1 }],
        { duration: 300, easing: 'ease-out' }
      );
    });
  });

})();
